import { useState } from "react";

interface JsonBlockProps {
	label: string;
	value: unknown;
}

/** Collapsed by default: raw model output is evidence for a reviewer, not the summary. */
export const JsonBlock = ({ label, value }: JsonBlockProps) => {
	const [open, setOpen] = useState(false);
	const text =
		typeof value === "string" ? value : JSON.stringify(value, null, 2);
	return (
		<div className="rounded-md border border-secondary">
			<button
				aria-expanded={open}
				className="w-full px-3 py-2 text-left text-sm text-secondary"
				onClick={() => setOpen((v) => !v)}
				type="button"
			>
				{open ? "▾" : "▸"} {label}
			</button>
			{open && (
				<pre className="overflow-x-auto px-3 pb-3 text-xs text-primary">
					{text}
				</pre>
			)}
		</div>
	);
};
